export default "__VITE_ASSET__Ci947ELA__"